

export default function CenterCanvasLogo(){

    return <img src="https://atlas-public-assets.s3.eu-west-1.amazonaws.com/canvas.png"
    style={{ maxWidth: "180px", maxHeight: "180px", "borderRadius": "5% 60% 5% 60%" }} />
}